module.exports = __webpack_public_path__ + "static/media/am_account-details.dec8f59d.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_account-details.md
// module id = 1085
// module chunks = 0